<template>
  <div class="content-wrap">
    <div class="header">
      <div class="title">IPTV</div>
    </div>
    <el-form ref="form" label-position="left" label-width="200px">
      <el-form-item label="Kích hoạt" style="margin-bottom: 10px">
        <el-switch v-model="active" />
      </el-form-item>
      <el-form-item label="Giao thức kết nối">
        <el-select
          v-model="protocolId"
          :disabled="!active"
          clearable
          placeholder="Select"
          style="width: 50%"
          @change="onChange"
        >
          <el-option
            v-for="item in protocolIdOptions"
            :key="item.id"
            :label="item.code"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div v-show="protocolId != ''">
      <h1>1. Thông tin kết nối</h1>
      <el-form ref="form2" label-position="left" label-width="200px">
        <el-form-item label="Token" style="margin-bottom: 10px">
          <el-input
            v-model="dataIP.token"
            type="textarea"
            :autosize="true"
            placeholder="Nhập thông tin"
          />
        </el-form-item>
        <el-form-item
          v-if="renderIPTVGateway"
          label="Đường dẫn IPTV Gateway"
          style="margin-bottom: 10px"
        >
          <el-input
            v-model="dataIP.iptv_gateway_path"
            placeholder="Nhập thông tin"
          />
        </el-form-item>
        <el-form-item
          label="Đường dẫn máy chủ IPTV"
          style="margin-bottom: 10px"
        >
          <el-input
            v-model="dataIP.iptv_server_path"
            placeholder="Nhập thông tin"
          />
        </el-form-item>
        <el-form-item
          v-if="renderIPTVUsed"
          label="Địa chỉ IP sử dụng từ PMS"
          style="margin-bottom: 10px"
        >
          <el-input
            v-model="dataIP.ip_from_pms"
            type="textarea"
            placeholder="Nhập thông tin"
          />
        </el-form-item>
      </el-form>
      <h1>2. Chức năng sử dụng</h1>
      <el-form ref="form3" label-position="top" label-width="200px">
        <el-form-item style="margin-bottom: 10px">
          <el-checkbox
            v-model="dataIP.display_greeting"
          >Hiển thị lời chào khi khách Check-in vào phòng</el-checkbox>
        </el-form-item>
        <el-form-item v-if="protocolId != 55" style="margin-bottom: 10px">
          <el-checkbox
            v-model="dataIP.display_message"
          >Hiển thị tin nhắn đến khách trong phòng</el-checkbox>
        </el-form-item>
        <el-form-item v-if="protocolId != 55" style="margin-bottom: 10px">
          <el-checkbox
            v-model="dataIP.display_info"
          >Hiển thị thông tin dịch vụ được sử dụng trong phòng</el-checkbox>
        </el-form-item>
      </el-form>
      <el-col class="bottom-btns-container">
        <el-button type="primary" @click="updateToken"> Tạo Token </el-button>
        <el-button type="danger" @click="updateIPTV"> Cập nhật </el-button>
      </el-col>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {
  getIPTVApi,
  getTokenIPTVApi,
  updateIPTVApi,
} from "@/api/connectConfig/iptv";
import { getProtocolListApi } from "@/api/common/code_base";
import { CellRenderColorPicker } from "@/utils/cellRenders.js";

import bus from "@/utils/bus";
import {
  getListBuildingApi,
  addBuildingApi,
  updateBuildingApi,
  deleteBuildingApi,
} from "@/api/Room/building.js";
import { Message } from "element-ui";
export default {
  components: {
    CellRenderColorPicker,
  },
  data() {
    return {
      viewIPGateway: [55, 56],
      viewIPused: [56],
      active: false,
      protocolId: "",
      checked: true,
      dataIP: {
        token: "",
        iptv_server_path: "",
        iptv_gateway_path: "",
        ip_from_pms: "",
        display_greeting: false,
        display_message: false,
        display_info: false,
      },
      protocolIdOptions: [],
    };
  },
  computed: {
    renderIPTVGateway() {
      return this.viewIPGateway.includes(this.protocolId);
    },
    renderIPTVUsed() {
      return this.viewIPused.includes(this.protocolId);
    },
  },
  watch: {},
  created() {
    this.getProtocolList();
  },

  mounted() {
    // this.attachData();
  },
  methods: {
    async getProtocolList() {
      let data = await getProtocolListApi();
      this.protocolIdOptions = data.data;
    },
    async getIpTV(id) {
      let data = await getIPTVApi({ protocolId: id });
      this.dataIP = data.data;
    },
    onChange(value) {
      if (value == "") {
        this.protocolId = null;
      } else {
        this.getIpTV(value);
      }
    },
    async updateToken() {
      let data = await getTokenIPTVApi({ protocolId: this.protocolId });
      this.dataIP.token = data.data.token;
    },
    async updateIPTV() {
      this.$confirm("Bạn chắc chắn muốn cập nhật IPTV này?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        updateIPTVApi(this.dataIP)
          .then(() => {
            this.$message({
              type: "success",
              message: "Bạn đã cập nhật IPTV thành công",
            });
            this.getIpTV(this.protocolId);
          })
          // .catch(() => {
          //   this.$message({
          //     type: "error",
          //     message: "Bạn chưa cập nhật IPTV thành công",
          //   });
          // });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
